<template>
  <div class="poster-box">
    <div class="picture-area">
      <WebpImage :imageInfo="{imageUrl: posterImage, width: 1240, height: 698, className: 'poster-thumb'}" />
    </div>
  </div>
</template>

<script>
import WebpImage from '@/components/image/WebpImage'
export default {
  name: 'PosterHorizontal',
  components: { WebpImage },
  props: {
    posterImage: {
      type: String,
      default: null
    },
    posterAltText: {
      type: String,
      default: null
    }
  }
}
</script>
